// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__37rUg","modalFooterButton":"ModalNotes_modalFooterButton__3LAhY"};